import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { ThemeProvider } from './ThemeContext';
import Background from './Background';
import Toggle from './ThemeToggle';
import Amplify from '@aws-amplify/core';
import awsconfig from './aws-exports-vercel';
Amplify.configure(awsconfig);

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <Background>
         <div className="fixed left-0 bottom-0 ml-4 mb-4 md:ml-6 md:mt-6 z-50">
            <Toggle />
          </div>
        <App/>
      </Background>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
